import { Button, ButtonProps } from "@platform/ui/components";
import * as React from "react";
import { Link } from "react-router";

export interface ButtonLinkProps
  extends
    Omit<React.ComponentProps<typeof Link>, "prefix">,
    Pick<ButtonProps, "variant" | "size" | "isLoading" | "prefix" | "suffix" | "svgOnly" | "align"> {}

export const ButtonLink = React.forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  ({ variant, size, isLoading, prefix, suffix, svgOnly, align, to, children, className, ...rest }, forwardedRef) => {
    return (
      <Button
        asChild
        variant={variant}
        size={size}
        isLoading={isLoading}
        prefix={prefix}
        suffix={suffix}
        svgOnly={svgOnly}
        align={align}
      >
        <Link to={to} ref={forwardedRef} className={className} {...rest}>
          {children}
        </Link>
      </Button>
    );
  },
);
ButtonLink.displayName = "ButtonLink";
